import { toast } from "react-toastify";
import axios from "axios";
import settings from "utils/settings";
import defaultErrorHandler from "actions/global/default-error-handler";

import {
  SCOOTER_TRIP_ACTIVE_LOADING,
  SCOOTER_TRIP_ACTIVE_ERROR,

  SCOOTER_TRIP_ACTIVE_FINISH,
  SCOOTER_TRIP_ACTIVE_FILTERS,
  SCOOTER_TRIP_ACTIVE_LIST,
} from "./constants";
import { requestCommonFilters, requestCommonSearch } from "../../common/requests";

const scooterUrl = `${settings.scooterUrl}api/`;
const ENDPOINT = "admin/trip/active";

export const setLoading = (status) => ({
  type: SCOOTER_TRIP_ACTIVE_LOADING,
  payload: status
});

export const search = (page = 0, size = 20, sort = "id,asc", filters = []) => dispatch => {
  dispatch(setLoading(true));
  requestCommonSearch(ENDPOINT, page, size, sort, filters, scooterUrl)
    .then(response => {
      dispatch({
        type: SCOOTER_TRIP_ACTIVE_LIST,
        payload: response
      });
    })
    .catch(error => {
      dispatch(defaultErrorHandler(error, SCOOTER_TRIP_ACTIVE_ERROR));
    });
};

export const getFilters = () => dispatch => {
  dispatch(setLoading(true));
  requestCommonFilters(ENDPOINT, scooterUrl)
    .then((response) => {
      dispatch({
        type: SCOOTER_TRIP_ACTIVE_FILTERS,
        payload: response.data
      });
    })
    .catch((error) => {
      dispatch(defaultErrorHandler(error, SCOOTER_TRIP_ACTIVE_ERROR));
    });
};

export const finish = (id, date = null) => dispatch => {
  dispatch(setLoading(true));
  const query = date ? `?time=${date}` : "";
  axios.post(`${scooterUrl}${ENDPOINT}/${id}/finish${query}`)
    .then((response) => {
      if (!date) {
        dispatch({
          type: SCOOTER_TRIP_ACTIVE_FINISH,
          payload: id
        });
      }
      if (response.data.message === "SUCCESS") {
        toast("Trip Finished", { type: toast.TYPE.SUCCESS });
      } else {
        toast("Can't finish trip. Something went wrong.", { type: toast.TYPE.ERROR });
      }
    })
    .catch((error) => {
      dispatch(defaultErrorHandler(error, SCOOTER_TRIP_ACTIVE_ERROR));
    });
};



// WEBPACK FOOTER //
// ./src/actions/scooter/trip-active/actions.js